import {MenuItem, Box} from '@mui/material'
import {styled} from '@mui/material/styles'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'

export const StyledMenuItem = styled(MenuItem)(({theme}) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: theme.typography.fontWeightRegular,
  textTransform: 'none',
  color: theme.palette.hpPrimaryDark, // not there
  padding: '0px 5px 0px 8px',
  marginTop: '8px'
}))

export const StyledBox = styled(Box)(() => ({
  padding: '8px'
}))

export const StyledAnchorMenuItem = styled(MenuItem)(({theme}) => ({
  color: theme.palette.hpPrimaryDark, // not there
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: theme.typography.fontWeightRegular,
  fontFamily: theme.typography.fontFamily,
  padding: '0px 8px 0px 8px',
  textDecoration: 'underline'
}))

export const StyledDivider = styled(Divider)(() => ({
  marginTop: '0px',
  marginBottom: '0px'
}))

export const StyledTypography = styled(Typography)(({theme}) => ({
  color: theme.palette.hpBlack,
  fontFamily: theme.typography.fontFamily,
  paddingLeft: '6px'
}))
